import * as React from 'react';
import { Button, Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, Box, TextField, CircularProgress } from '@mui/material/';
import RefreshIcon from '@mui/icons-material/Refresh';
import axios from 'axios';

export default function CodeDialog(props) {
    const { codeDialogStatus, setCodeDialogStatus, accessCode, setAccessCode, accessCodeErrors, setAccessCodeErrors, formData, preferdMethod, sendMessageDO, sendPostDO } = props;

    const [loader, setLoader] = React.useState(false);
    const [showError, setShowError] = React.useState(false);
    const cellSize = 1.7;
    const borderRadius = 3;
    const style = {
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "none",
        },
        "& input[type=number]": {
            MozAppearance: "textfield",
        },
    }

    React.useEffect(() => {

        return () => {
            console.log('exit');
        }
    }, []);

    const sendMessage = async () => {
        setLoader(true);
        setShowError(false);
        console.log('in send code function');
        let errors = { ...accessCodeErrors, };
        console.log('accessCode?.val1: ', accessCode?.val1);
        accessCode?.val1 === null ? errors.val1 = true : errors.val1 = false;
        accessCode?.val2 === null ? errors.val2 = true : errors.val2 = false;
        accessCode?.val3 === null ? errors.val3 = true : errors.val3 = false;
        accessCode?.val4 === null ? errors.val4 = true : errors.val4 = false;
        console.log('errors: ', errors);

        setAccessCodeErrors(errors);

        // console.log('err:', err);
        if (!Object.keys(errors).find((i) => errors[i] === true)) {
            console.log('no errors');
            const data = { otpCode: accessCode?.val1 + accessCode?.val2 + accessCode?.val3 + accessCode?.val4, brandId: 102, userID: '' };
            if (preferdMethod[0] === 'Email') {
                data.emailAddress = formData?.email;
            } else {
                data.phoneNumber = formData?.phone;
            }
            console.log('data: ', data);
            await axios.post(`https://alove-dev.algoaitech.io/auth/verifyCode`, data)
                .then(res => {
                    console.log('res: ', res);
                    sendPostDO();
                    // here come code for sendpost
                    setLoader(false);
                })
                .catch(error => {
                    console.error('error from deploy settings:', error)
                    console.error('error from deploy settings:', error?.response?.data?.status)
                    if (error?.response?.status === 422) {
                        setShowError(true);
                        setLoader(false);
                    }
                    // reject(error);
                })
        }
    };

    return (
        <React.Fragment>
            <Dialog
                PaperProps={{
                    style: { borderRadius: 25 }
                }}
                sx={{
                    backdropFilter: "blur(5px) sepia(5%)",
                    textAlign: "center",
                    borderRadius: 10
                }}
                // sx={{ textAlign: "center" }}
                open={codeDialogStatus}
                onClose={() => setCodeDialogStatus(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ textAlign: "center" }} id="alert-dialog-title" mt={5}>
                    {/* {"Thank you for registering!"} */}
                    <Typography variant="h4" component="h4">
                        We’ve sent a code to your  {preferdMethod[0]}
                    </Typography>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" mt={0} mb={15}>
                        <Grid
                            container
                            spacing={0}
                            direction="row"
                            alignItems="center"
                            justifyContent="center"
                            mt={0}
                        >
                            <Grid item xs={12} lg={12} xl={12} >
                                <Typography variant="h6" component="h6">
                                    To validate your registration
                                </Typography>
                            </Grid>
                            <Grid item xs={12} lg={12} xl={12} sx={{ m: 1, mt: 5 }}>
                                <Typography variant="h6" component="h6">
                                    Please enter the code:
                                </Typography>
                            </Grid>
                            <Grid item xs={7} lg={7} md={7} xl={7}>
                                <Grid
                                    container
                                    spacing={0}
                                    // direction="row"
                                    gap={2}
                                    alignItems="center"
                                    justifyContent="center"
                                    mt={0}
                                >
                                    <Grid item xs={cellSize} lg={cellSize} md={cellSize} xl={cellSize}>
                                        <TextField
                                            value={accessCode?.val1}
                                            id="val1"
                                            type="number"
                                            name={`val1`}
                                            sx={style}
                                            variant="outlined"
                                            error={accessCodeErrors?.val1}
                                            onChange={(e) => {

                                                setAccessCode({ ...accessCode, val1: e?.target?.value })
                                                // const element = e.target;
                                                // console.log('element: ', element);
                                                // const nextSibling = element.nextElementSibling;
                                                // console.log('nextSibling: ', nextSibling);
                                                // nextSibling ? nextSibling.focus() : element.blur();
                                                // window.select('val2').focus();

                                            }}
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1)
                                            }}
                                            InputProps={{ sx: { borderRadius: borderRadius, fontSize: 25 } }}
                                            autoFocus={true}
                                        />
                                    </Grid>
                                    <Grid item xs={cellSize} lg={cellSize} md={cellSize} xl={cellSize} >
                                        <TextField
                                            value={accessCode?.val2}
                                            id="val2"
                                            type="number"
                                            name={`val2`}
                                            sx={style}
                                            variant="outlined"
                                            error={accessCodeErrors?.val2}
                                            onChange={(e) => setAccessCode({ ...accessCode, val2: e?.target?.value })}
                                            InputProps={{ sx: { borderRadius: borderRadius, fontSize: 25 } }}
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={cellSize} lg={cellSize} md={cellSize} xl={cellSize} >
                                        <TextField
                                            value={accessCode?.val3}
                                            id="val3"
                                            type="number"
                                            sx={style}
                                            variant="outlined"
                                            error={accessCodeErrors?.val3}
                                            onChange={(e) => setAccessCode({ ...accessCode, val3: e?.target?.value })}
                                            InputProps={{ sx: { borderRadius: borderRadius, fontSize: 25 } }}
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1)
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={cellSize} lg={cellSize} md={cellSize} xl={cellSize}>
                                        <TextField
                                            value={accessCode?.val4}
                                            id="val4"
                                            type="number"
                                            sx={style}
                                            variant="outlined"
                                            error={accessCodeErrors?.val4}
                                            onChange={(e) => setAccessCode({ ...accessCode, val4: e?.target?.value })}
                                            InputProps={{ sx: { borderRadius: borderRadius, fontSize: 25 } }}
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 1)
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} lg={12} xl={12} sx={{ m: 1, mt: 5 }}>
                                    {showError ? (
                                        <Typography variant="h6" component="h6" color={'red'}>
                                            You’ve entered a wrong code
                                        </Typography>) : null}
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions >
                    <Box
                        display="flex"
                        width={600} height={160}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Grid
                            container
                            spacing={0}
                            // direction="row"
                            alignItems="center"
                            justifyContent="center"
                            mt={0}
                        >
                            <Grid item xs={12} lg={12} xl={12} sx={{ m: 1 }}>
                                {!loader ? (
                                    <Typography variant="h6" component="h6" onClick={() => sendMessageDO()} sx={{ cursor: 'pointer' }}>
                                        <RefreshIcon fontSize='small' />
                                        Resend code
                                    </Typography>
                                ) : null}
                            </Grid>
                            <Grid item xs={12} lg={12} xl={12} sx={{ m: 1 }}>
                                {loader ? (<CircularProgress />) : (
                                    <Button
                                        style={{
                                            // flex: '1 0 0',
                                            width: "45%",
                                            borderRadius: 35,
                                            backgroundColor: "#000000",
                                            padding: " 10px 35px 10px 35px",
                                            fontcellSize: "14px"
                                        }} variant="contained"
                                        onClick={() => sendMessage()}
                                    >
                                        submit
                                    </Button>
                                )};
                            </Grid>
                        </Grid>
                    </Box>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}